import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Calendar = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <path
          d='M3.75 10.25H20.25M7.75 5.25V3.25M16.25 5.25V3.25M5.75 20.75H18.25C19.3546 20.75 20.25 19.8546 20.25 18.75V7.25C20.25 6.14543 19.3546 5.25 18.25 5.25H5.75C4.64543 5.25 3.75 6.14543 3.75 7.25V18.75C3.75 19.8546 4.64543 20.75 5.75 20.75Z'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <rect
          x='6.99951'
          y='13.0005'
          width='2'
          height='2'
          rx='0.5'
          fill='currentColor'
        />
        <rect
          x='6.99951'
          y='17.0005'
          width='2'
          height='2'
          rx='0.5'
          fill='currentColor'
        />
        <rect
          x='10.9995'
          y='13.0005'
          width='2'
          height='2'
          rx='0.5'
          fill='currentColor'
        />
        <rect
          x='10.9995'
          y='17.0005'
          width='2'
          height='2'
          rx='0.5'
          fill='currentColor'
        />
        <rect
          x='14.9995'
          y='13.0005'
          width='2'
          height='2'
          rx='0.5'
          fill='currentColor'
        />
      </>
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.5 3.25C8.5 2.83579 8.16421 2.5 7.75 2.5C7.33579 2.5 7 2.83579 7 3.25V4.5H5.75C4.23122 4.5 3 5.73122 3 7.25V18.75C3 20.2688 4.23122 21.5 5.75 21.5H18.25C19.7688 21.5 21 20.2688 21 18.75V7.25C21 5.73122 19.7688 4.5 18.25 4.5H17V3.25C17 2.83579 16.6642 2.5 16.25 2.5C15.8358 2.5 15.5 2.83579 15.5 3.25V4.5H8.5V3.25ZM4.5 7.25C4.5 6.55964 5.05964 6 5.75 6H18.25C18.9404 6 19.5 6.55964 19.5 7.25V9.5H4.5V7.25ZM7 13C7 12.7239 7.22386 12.5 7.5 12.5H8.5C8.77614 12.5 9 12.7239 9 13V14C9 14.2761 8.77614 14.5 8.5 14.5H7.5C7.22386 14.5 7 14.2761 7 14V13ZM7.5 16.5C7.22386 16.5 7 16.7239 7 17V18C7 18.2761 7.22386 18.5 7.5 18.5H8.5C8.77614 18.5 9 18.2761 9 18V17C9 16.7239 8.77614 16.5 8.5 16.5H7.5ZM11 13C11 12.7239 11.2239 12.5 11.5 12.5H12.5C12.7761 12.5 13 12.7239 13 13V14C13 14.2761 12.7761 14.5 12.5 14.5H11.5C11.2239 14.5 11 14.2761 11 14V13ZM11.5 16.5C11.2239 16.5 11 16.7239 11 17V18C11 18.2761 11.2239 18.5 11.5 18.5H12.5C12.7761 18.5 13 18.2761 13 18V17C13 16.7239 12.7761 16.5 12.5 16.5H11.5ZM15 13C15 12.7239 15.2239 12.5 15.5 12.5H16.5C16.7761 12.5 17 12.7239 17 13V14C17 14.2761 16.7761 14.5 16.5 14.5H15.5C15.2239 14.5 15 14.2761 15 14V13Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
